__turbopack_context__.v({
  "inlineEditor": "SlidesCanvas-module__FuInwG__inlineEditor",
  "pageBeingRead": "SlidesCanvas-module__FuInwG__pageBeingRead",
  "slidesCaretBlink": "SlidesCanvas-module__FuInwG__slidesCaretBlink",
  "slidesReadPulse": "SlidesCanvas-module__FuInwG__slidesReadPulse",
  "typingCaret": "SlidesCanvas-module__FuInwG__typingCaret",
});
